import React from "react"
import { Color, GrayGridTheme } from "../../../data/style/variables"
import { CtaArrow, Rotations, Sizes } from "../CtaArrow/CtaArrow"
import { Grid } from "../Grid/Grid"
import { RevealBlockAnimation } from "../RevealBlockAnimation/RevealBlockAnimation"
import { Section } from "../Section/Section"
import { RoutePath } from "../../../data/RoutePath"
import TransitionLink from "gatsby-plugin-transition-link"
import { TitleH2 } from "../Typography/Typography"
import {
  PageTitle,
  Typography,
  TypographyTypes,
} from "../Typography/Typography"
import {
  ArrowContainerElement,
  ContainerElement,
  TitleContainerElement,
} from "./styled"

type ClientProps = {
  title: string
  description: string
}

export const Client: React.FC<ClientProps> = ({
  title,
  description,
  children,
}) => {
  return (
    <ContainerElement>
      <Grid
        gridElementProps={{
          baseHeight: "calc(100vh)",
          lineColor: "rgba(0,0,0,.1)",
          color: GrayGridTheme.color,
          noOverFlowHidden: true,
        }}
      >
        <Section>
          <TitleContainerElement>
            <RevealBlockAnimation background={Color.Black}>
              <PageTitle color={Color.Black}>{title}</PageTitle>
            </RevealBlockAnimation>
          </TitleContainerElement>
          <TitleH2 color={Color.Black}>{description}</TitleH2>
          <TransitionLink
            to={RoutePath.Home}
            exit={{ length: 1 }}
            entry={{ delay: 1 }}
          >
            <ArrowContainerElement>
              <CtaArrow
                size={Sizes.large}
                rotation={Rotations.left}
                color={Color.Black}
              />
            </ArrowContainerElement>
          </TransitionLink>
        </Section>
      </Grid>
      {children}
    </ContainerElement>
  )
}
